import { useMemo, useState, useEffect } from "react";
// import { COLUMNS } from "../column";
import { useRowSelect, useTable } from "react-table";
// import { UseRowSelectColumn, useRowSelectColumn } from "@lineup-lite/hooks";
import AddToZoho from './AddToZoho';
import Swal from 'sweetalert2'


const Table = ({ mockData, selectData, unselectData, projectID, preselectedRows}) => {
  const [showSummAlert, setShowSummAlert] = useState(false)
  const [invalidEmail, setInvalidEmail] = useState(false)


  useEffect(() => {
    if(invalidEmail){
      Swal.fire({
        icon: 'error',
        title: 'Invalid email.',
        showConfirmButton: false,
        timer: 2000
     })
    }
  }, [invalidEmail])

  useEffect(() => {
    if(showSummAlert){
      Swal.fire({
        icon: 'error',
        title: 'Summary too long.',
        showConfirmButton: false,
        timer: 2000
     })
    }
  }, [showSummAlert])

  const columns = useMemo(() =>  [
    {
      Header: "id",
      accessor: "id",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({value})  => (
        <span>{value === '0'? "No information":value}</span>
      )
    },
    {
      Header: "Add to Zoho",
      accessor: "in_zoho",
      Cell: ({ cell }) => (
        <div>
          <AddToZoho
                  expert_id={cell.row.values.id}
                  in_zoho={cell.row.values.in_zoho}
                  status={cell.row.values.status}
                  summLength={cell.row.values.summLength}
                  setShowSummAlert={setShowSummAlert}
                  exObject={cell.row.values.email}
                  setInvalidEmail={setInvalidEmail}
                  projectID={projectID}
               />
        </div>
      )
    },
    {
      Header: "Summary length",
      accessor: "summLength",
    },
  ], []); // memoize before adding to useTable hook
  const data = useMemo(() => [...mockData], [mockData]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns, // useTable hook takes in memoized columns and data to be displayed
    data,
    initialState:{
      hiddenColumns: ["id", "summLength"],
      selectedRowIds: preselectedRows?.reduce((acc, id) => ({ ...acc, [id]: true }), {}) || {} // Preselect rows based on provided IDs
    }
  },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: 'checkbox',
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
          ),
          Cell: ({ row }) => (
            <input type="checkbox" {...row.getToggleRowSelectedProps()} />
          ),
        },
        ...columns,
      ]);
    });
    // useRowSelectColumn
  // );

  return (
    <>
      {/* apply the table props */}
      <table {...getTableProps()} className="min-w-full divide-y divide-gray-200 prjIn-table">
          <thead>
          {
              // Loop over the header rows
              headerGroups.map((headerGroup) => (
              // Apply the header row props
              <tr {...headerGroup.getHeaderGroupProps()}>
                  {
                  // Loop over the headers in each row
                  headerGroup.headers.map((column) => (
                      // Apply the header cell props
                      <th {...column.getHeaderProps()}>
                          {column.render("Header")}
                          {column.id === 'selection' && column.render('Summary')}

                      </th>
                  ))
                  }
              </tr>
              ))
          }
          </thead>
          {/* Apply the table body props */}
          <tbody {...getTableBodyProps()}>
          {
              // Loop over the table rows
              rows.map((row, i) => {
              // Prepare the row for display
              prepareRow(row);
              return (
                  <tr {...row.getRowProps()} onChange={(e) => {
                      if (e.target.checked) {
                        if(row.values.in_zoho === "yes"){
                          selectData(row.values)
                        }
                        else{
                          row.original.validationError = "Not added in zoho"
                          Swal.fire({
                            icon: 'error',
                            title: 'Please add the profile to zoho first.',
                            showConfirmButton: false,
                            timer: 2000
                         })
                        }
                      } else {
                          unselectData(row.values)
                          if (!(row.values.in_zoho === "yes")) {
                            row.original.validationError = ""
                          }
                      }
                    }} className={row.original.validationError ? 'invalid-row' : ''}>
                  {
                      // Loop over the rows cells
                      row.cells.map((cell) => {
                      // Apply the cell props
                      return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                      })
                  }
                  </tr>
              );
              })
          }
          </tbody>
      </table>
    </>
  );
};

export default Table;